/**
 * Configure video component
 * @param {string} videoId.
 * @param {string} componentId.
 * @param {string} ctaDesktop.
 * @param {string} ctaMobile.
 */
function setVideoComponent(videoId, componentId, ctaDesktop, ctaMobile) {
  const getVideo = document.getElementById(videoId);
  const getCtaDesktop = document.getElementById(ctaDesktop);
  const getCtaMobile = document.getElementById(ctaMobile);
  const getComponent = document.getElementById(componentId);
  const PLAYING = 'playing';

  /**
   * Play button handler
   */
  const playHandler = () => {
    getComponent.classList.add(PLAYING);
    getVideo.setAttribute('controls', 'controls');
    getVideo.play();
  };

  /**
   * Pause button handler
   */
  const pauseHandler = () => {
    getComponent.classList.remove(PLAYING);
    getVideo.pause();
  };

  /**
   * End button handler
   */
  const endHandler = () => {
    getComponent.classList.remove(PLAYING);
    if (getVideo.hasAttribute('controls')) {
      getVideo.removeAttribute('controls');
    }
  };

  /**
   * Loading handler
   */
  const loadingHandle = () => {
    // eslint-disable-next-line
    console.log('Video is waiting for more data.');
  };

  getVideo.addEventListener('ended', endHandler, false);
  getVideo.addEventListener('pause', pauseHandler, false);
  getVideo.addEventListener('waiting', loadingHandle, false);
  getCtaDesktop.addEventListener('click', playHandler);
  getCtaMobile.addEventListener('click', playHandler);
}

export default setVideoComponent;
